import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { TableActions } from '../table.actions';
import { UpdateApprovalService } from '@core/services/update-approvals';
import { catchError, tap, throwError } from 'rxjs';
import { NotificationFacade } from '@core/facades/notification.facade';
import { OrderService } from '@core/services/order.service';
import { MutualFundService } from '@core/services/mutual-fund.service';

@Injectable({
  providedIn: 'root',
})
export class OrderApprovalsHandler {
  constructor() {}
  mutualFundService = inject(MutualFundService);
  notify = inject(NotificationFacade);

  handleOrderApprovalsLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    this.mutualFundService.getAllMFDTRXRequests({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'orderApprovals',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'orderApprovals',
            error: error.message,
          })
        );
      },
    });
  }

  approveOrRejectOrder(
    ctx: StateContext<TableStateModel>,
    action: TableActions.ApproveOrRejectOrder
  ) {
    return this.mutualFundService
      .approveOrRejectOrder(action.payload.id, action.payload.action)
      .pipe(
        tap(() => {

          const currentState = ctx.getState();
          const updatedOrders = currentState.orderApprovals?.data.map(
            (order) =>
              order.id === action.payload.id
                ? {
                    ...order,
                    status:
                      action.payload.action === 'approved'
                        ? 'approved'
                        : 'rejected',
                  }
                : order
          );
          ctx.patchState({
            orderApprovals: {
              ...currentState.orderApprovals,
              data: updatedOrders,
            },
          } as Partial<TableStateModel>);
        }),
        catchError((error) => {
          this.notify.error('Failed to approve update');
          return throwError(() => error);
        })
      );
  }

  filterOrderApprovalList(
    ctx: StateContext<TableStateModel>,
    action: TableActions.FilterApprovalList
  ) {
    const query = action.payload.filter;
    this.mutualFundService.getAllMFDTRXRequests(undefined, query).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'orderApprovals',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'updateApprovals',
            error: error.message,
          })
        );
      },
    });
  }
}
